<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Mission & Vission </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm about-us section-banner-bg-1">
    <div class="container">
        <div class="widget_title inner-title">
            <h4>MISSION & VISSION</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="main-timeline">
                    <div class="timeline">
                        <a href="#" class="timeline-content">
                            <div class="timeline-icon">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/mission.png"
                                    alt="Mission | GHRSCF" class="img-fluid" />
                            </div>
                            <h3 class="title">MISSION</h3>
                            <p class="description text-justify">
                                Our efforts are dedicated to imbibe the way of life through Sports &
                                Culture in society. Our endeavor is to support and strengthen the Sports
                                & Cultural environment and contribute to
                                enhancement of such activities in society.
                            </p>
                        </a>
                    </div>
                    <div class="timeline">
                        <a href="#" class="timeline-content">
                            <div class="timeline-icon">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/vision.png"
                                    alt="Vision | GHRSCF" class="img-fluid" />
                            </div>
                            <h3 class="title">VISION</h3>
                            <p class="description text-justify">
                                To provide farsighted active platform for promoting initiatives in the
                                sphere of Sports and Culture.
                            </p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
